import { render, staticRenderFns } from "./ErpOrderInfo.vue?vue&type=template&id=6cad4bbc&scoped=true&"
import script from "./ErpOrderInfo.vue?vue&type=script&lang=js&"
export * from "./ErpOrderInfo.vue?vue&type=script&lang=js&"
import style0 from "./ErpOrderInfo.vue?vue&type=style&index=0&id=6cad4bbc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cad4bbc",
  null
  
)

export default component.exports